/**
 * Product Preview Quiz — PRE-ACQUISTO
 *
 * Stesso questionario lean del briefing v4 (3 step). Differenze:
 *  - No auth Shopify (cliente non ha ancora ordinato)
 *  - Genera 7 carte preview (3 SS via AI + 4 generali dal pool)
 *  - Mostra 4 varianti prodotto come CTA add-to-cart
 *  - Risposte questionario → line item properties Shopify cart
 *  - sessionId dal server → _preview_session_id nelle cart props
 */
(function () {
  'use strict';

  const AUTOSAVE_KEY = 'ci-preview-quiz:state';
  const DEFAULT_PREVIEW_ENDPOINT = 'https://shopify-memes-411b.vercel.app/api/cards/preview-public';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }
  function debounce(fn, ms) {
    let t;
    return function () { clearTimeout(t); const args = arguments, ctx = this; t = setTimeout(() => fn.apply(ctx, args), ms); };
  }

  /* Pool filtering (riutilizzo logica v4) */
  const GEN_Z_KEYWORDS = ['tiktok','brainrot','chatgpt','tinder','bumble','onlyfans','reels','reel','screenshot','scroll','mood','vibe','cringe','pov','aesthetic','rizz','ick','situationship','ghosting','spid'];
  const ADULT_KEYWORDS = ['scopare','scopata','scopa','sesso','sex','tradire','tradisce','tette','culo','cazzo','figa','pene','troia','puttana','pornhub','vibratore','squirt'];
  const MATURE_KEYWORDS = ['mutuo','suocera','pensione','colonscopia','glicemia','colesterolo','condominio','autovelox'];

  function computeMaturity(age, occasion) {
    const baseAge = { under25: 20, '25-35': 40, '35-50': 70, '50plus': 90 }[age] || 50;
    const occMod = { matrimonio: 15, laurea: -5, addio: -10, compleanno: 0, altro: 0 }[occasion] || 0;
    return Math.max(0, Math.min(100, baseAge + occMod));
  }
  function computeSpice(vibe, occasion) {
    const baseVibe = { irriverente: 30, chaos: 55, spicy: 90 }[vibe] || 50;
    const occMod = { addio: 20, matrimonio: -20, laurea: -10, compleanno: 0, altro: 0 }[occasion] || 0;
    return Math.max(0, Math.min(100, baseVibe + occMod));
  }
  function containsAny(text, keywords) {
    const lower = String(text || '').toLowerCase();
    return keywords.some((k) => lower.includes(k));
  }
  function filterPool(cards, maturity, spice) {
    return cards.filter((c) => {
      if (maturity > 70 && containsAny(c, GEN_Z_KEYWORDS)) return false;
      if (maturity < 35 && containsAny(c, MATURE_KEYWORDS)) return false;
      if (spice < 50 && containsAny(c, ADULT_KEYWORDS)) return false;
      return true;
    });
  }

  /* Copy adattivo: titoli/lead cambiano in base a età+occasione */
  function adaptiveCopy(state) {
    const age = state.age || '';
    const occ = state.occasion || '';
    const vibe = state.vibe || '';
    const spicy = vibe === 'spicy' || (vibe === 'chaos' && (age === 'under25' || age === '25-35'));

    let step2Title = 'parlami di lui/lei';
    if (occ === 'addio') step2Title = 'parlami del <span class="ci-highlight ci-highlight--pink">disastro</span>';
    else if (occ === 'matrimonio') step2Title = 'parlami degli <span class="ci-highlight">sposi</span>';
    else if (occ === 'laurea') step2Title = 'parlami del/della <span class="ci-highlight">dottore</span>';

    let step2Lead = 'Più dettagli, più le carte spaccano.';
    if (spicy) step2Lead = 'Non risparmiamo nessuno. Spara dettagli.';

    return {
      step1: { title: 'prova memando in <span class="ci-highlight">3 minuti</span>', lead: 'Rispondi a 3 domande veloci. Ti facciamo vedere 3 carte personalizzate. Solo dopo decidi se comprare.' },
      step2: { title: step2Title, lead: step2Lead },
      step3: { title: 'ultima cosa: una <span class="ci-highlight ci-highlight--pink">storia vera</span>?', lead: 'Opzionale. Se hai un aneddoto epico qui sotto, le carte saranno spettacolari. Sennò vai avanti.' },
    };
  }

  class PreviewQuiz {
    constructor(root) {
      this.root = root;
      this.previewEndpoint = root.dataset.previewEndpoint || DEFAULT_PREVIEW_ENDPOINT;
      if (!/^https?:\/\//i.test(this.previewEndpoint)) this.previewEndpoint = DEFAULT_PREVIEW_ENDPOINT;
      this.productHandle = root.dataset.productHandle || '';
      this.productTitle = root.dataset.productTitle || '';

      this.state = this.loadState() || {
        age: '', occasion: '', vibe: '',
        honoree: '', friends: [], lore: '',
        extraStory: '',
        email: '', consent: true,
      };
      if (this.state.consent === undefined) this.state.consent = true;
      if (!this.state.email) this.state.email = '';

      this.step = 1;
      this.totalSteps = 4;                   // step 4 = email gate (in-flow)
      this.sessionId = null;                 // set after successful AI call, included in cart props
      this.email = this.state.email || null; // mirror in instance for cart props
      this.emailGateUnlocked = false;        // true after newsletter signup succeeds
      this.regenerationsUsed = 0;            // user can regenerate exactly 1 time
      this.MAX_REGENERATIONS = 1;

      this.cacheEls();
      this.bind();
      this.applyState();
      this._injectFormCSS();
      this.renderStep();
    }

    cacheEls() {
      const r = this.root;
      this.elStepNum = $('[data-brief-step-num]', r);
      this.elStepNumF = $('[data-brief-step-num-footer]', r);
      this.elProgFill = $('[data-brief-progress-fill]', r);
      this.elPrev = $('[data-brief-prev]', r);
      this.elNext = $('[data-brief-next]', r);
      this.elSubmit = $('[data-brief-submit]', r);
      this.elToast = $('[data-brief-toast]', r);
      this.elReveal = $('[data-brief-reveal]', r);
      this.elPackages = $('[data-preview-packages]', r);
      this.elMockups = $('[data-preview-mockups]', r);
      this.elAftersale = $('[data-preview-aftersale]', r);
      this.steps = $$('.ci-brief__step', r);
      // Step 4 email (no more modal — integrato nel flow)
      this.elEmailInput = $('[data-preview-email-input]', r);
      this.elEmailConsent = $('[data-preview-email-consent]', r);
      this.elEmailError = $('[data-preview-email-error]', r);
      this.newsletterTags = r.dataset.newsletterTags || 'newsletter,preview-quiz';
    }

    bind() {
      this.persistDebounced = debounce(() => this.persist(), 600);

      this.elPrev?.addEventListener('click', () => this.go(this.step - 1));
      this.elNext?.addEventListener('click', () => this.go(this.step + 1));
      this.elSubmit?.addEventListener('click', () => this.onSubmitClick());

      $$('[data-brief-age]', this.root).forEach((b) => b.addEventListener('click', () => { this.state.age = b.dataset.briefAge; this.refreshChip('age'); this.persistDebounced(); }));
      $$('[data-brief-occasion]', this.root).forEach((b) => b.addEventListener('click', () => { this.state.occasion = b.dataset.briefOccasion; this.refreshChip('occasion'); this.persistDebounced(); }));
      $$('[data-brief-vibe]', this.root).forEach((b) => b.addEventListener('click', () => { this.state.vibe = b.dataset.briefVibe; this.refreshChip('vibe'); this.persistDebounced(); }));

      // ── Friends: aggiunta automatica on blur (oltre al bottone +) ──
      const friendName = $('[data-brief-input="friend-name"]', this.root);
      const friendRole = $('[data-brief-input="friend-role"]', this.root);
      this.elFriendAddRow = $('[data-brief-friend-add-row]', this.root);
      this.elFriendAddBtn = $('[data-brief-add="friends"]', this.root);
      this.elFriendHint = $('[data-brief-friend-hint]', this.root);
      const tryAddFriend = () => {
        const n = (friendName?.value || '').trim();
        const r = (friendRole?.value || '').trim();
        if (!n) return false;
        if (this.state.friends.length >= 3) return false;
        this.state.friends.push({ name: n, role: r });
        if (friendName) friendName.value = '';
        if (friendRole) friendRole.value = '';
        this.renderFriends();
        this.persist();
        return true;
      };
      this.tryAddFriend = tryAddFriend;
      this.elFriendAddBtn?.addEventListener('click', () => tryAddFriend());
      // Enter su nome o ruolo → conferma
      [friendName, friendRole].forEach((inp) => {
        inp?.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            if (tryAddFriend()) friendName?.focus();
          }
        });
      });
      // Blur dal pair name/role: se l'utente esce dal blocco senza confermare, auto-add
      this.elFriendAddRow?.addEventListener('focusout', () => {
        // setTimeout per leggere il focus DOPO il blur
        setTimeout(() => {
          const next = document.activeElement;
          if (next && (next === friendName || next === friendRole || next === this.elFriendAddBtn)) return;
          tryAddFriend();
        }, 50);
      });

      // ── Input testo standard (honoree/lore/extraStory) ──
      $$('[data-brief-input]', this.root).forEach((input) => {
        const k = input.dataset.briefInput;
        if (['friend-name', 'friend-role', 'email'].includes(k)) return;
        input.addEventListener('input', () => { this.state[k] = input.value; this.persistDebounced(); });
      });

      // ── Step 4 · email input ──
      this.elEmailInput?.addEventListener('input', () => {
        this.state.email = this.elEmailInput.value;
        // invalida il "gate sbloccato" se l'utente cambia email dopo averla già confermata
        if (this.email && this.email !== this.state.email.trim()) {
          this.email = null;
          this.emailGateUnlocked = false;
        }
        this._clearEmailError();
        this._refreshSubmitState();
        this.persistDebounced();
      });
      this.elEmailInput?.addEventListener('blur', () => {
        const v = (this.elEmailInput.value || '').trim();
        if (v && !this._isValidEmail(v)) this._showEmailError('Email non valida.');
      });
      this.elEmailInput?.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          if (!this.elSubmit?.disabled) this.onSubmitClick();
        }
      });
      this.elEmailConsent?.addEventListener('change', () => {
        this.state.consent = this.elEmailConsent.checked;
        this._refreshSubmitState();
        this.persistDebounced();
      });

      // Add to cart per variant
      $$('[data-preview-add-to-cart]', this.root).forEach((btn) => {
        btn.addEventListener('click', () => this.addToCart(btn.dataset.previewAddToCart));
      });
    }

    _isValidEmail(s) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);
    }
    _showEmailError(msg) {
      if (this.elEmailError) {
        this.elEmailError.textContent = msg;
        this.elEmailError.hidden = false;
      }
      this.elEmailInput?.classList.add('ci-brief__input--invalid');
    }
    _clearEmailError() {
      if (this.elEmailError) this.elEmailError.hidden = true;
      this.elEmailInput?.classList.remove('ci-brief__input--invalid');
    }
    _refreshSubmitState() {
      if (!this.elSubmit) return;
      // Solo allo step 4 il submit ha senso. Per gli altri step è nascosto.
      if (this.step !== this.totalSteps) return;
      const email = (this.state.email || '').trim();
      const consent = this.state.consent !== false;
      const ok = this._isValidEmail(email) && consent && this._briefingComplete();
      this.elSubmit.disabled = !ok;
    }
    _briefingComplete() {
      return !!(this.state.honoree && this.state.age && this.state.occasion && this.state.vibe);
    }
    _esc(s) {
      return String(s || '').replace(/[&<>"']/g, (c) => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' })[c]);
    }

    refreshChip(field) {
      const value = this.state[field];
      const attr = `data-brief-${field}`;
      $$(`[${attr}]`, this.root).forEach((b) => {
        b.classList.toggle('ci-brief__chip--active', b.getAttribute(attr) === value);
      });
    }

    applyState() {
      this.refreshChip('age'); this.refreshChip('occasion'); this.refreshChip('vibe');
      $$('[data-brief-input]', this.root).forEach((input) => {
        const k = input.dataset.briefInput;
        if (['friend-name','friend-role'].includes(k)) return;
        if (typeof this.state[k] === 'string') input.value = this.state[k];
      });
      if (this.elEmailConsent) this.elEmailConsent.checked = this.state.consent !== false;
      this.renderFriends();
    }

    renderFriends() {
      const grid = $('[data-brief-list="friends"]', this.root);
      if (!grid) return;
      const friendName = $('[data-brief-input="friend-name"]', this.root);
      const friendRole = $('[data-brief-input="friend-role"]', this.root);
      const esc = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' })[c]);
      grid.innerHTML = '';
      this.state.friends.forEach((f, i) => {
        const div = document.createElement('div');
        div.className = 'ci-brief__friend';
        div.setAttribute('role', 'button');
        div.setAttribute('tabindex', '0');
        div.setAttribute('title', 'Clicca per modificare');
        div.innerHTML = `
          <span class="ci-brief__friend-text"><strong>${esc(f.name)}</strong> <span style="opacity:.7">· ${esc(f.role) || '—'}</span></span>
          <button type="button" class="ci-brief__friend-remove" aria-label="Rimuovi" data-friend-remove>✕</button>
        `;
        // Modifica al click sul chip (escluso il bottone ✕)
        const editFriend = () => {
          // Se inputs già pieni con valori non vuoti diversi dall'amico cliccato,
          // confermali prima per non perderli.
          const nVal = (friendName?.value || '').trim();
          if (nVal && this.state.friends.length < 3 && nVal !== f.name) {
            const rVal = (friendRole?.value || '').trim();
            this.state.friends.push({ name: nVal, role: rVal });
            // adjust index: l'amico aggiunto va in fondo, indice di f resta valido
          }
          // Rimuovi l'amico dall'array e popola gli input per editing
          this.state.friends.splice(i, 1);
          if (friendName) friendName.value = f.name || '';
          if (friendRole) friendRole.value = f.role || '';
          this.renderFriends();
          this.persist();
          friendName?.focus();
        };
        div.addEventListener('click', (e) => {
          if (e.target.closest('[data-friend-remove]')) return;
          editFriend();
        });
        div.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); editFriend(); }
        });
        div.querySelector('[data-friend-remove]').addEventListener('click', (e) => {
          e.stopPropagation();
          this.state.friends.splice(i, 1);
          this.renderFriends();
          this.persist();
        });
        grid.appendChild(div);
      });
      this._refreshFriendsAddState();
    }

    _refreshFriendsAddState() {
      const count = this.state.friends.length;
      const max = 3;
      const atMax = count >= max;
      const friendName = $('[data-brief-input="friend-name"]', this.root);
      const friendRole = $('[data-brief-input="friend-role"]', this.root);
      if (this.elFriendAddRow) this.elFriendAddRow.classList.toggle('is-disabled', atMax);
      if (this.elFriendAddBtn) this.elFriendAddBtn.disabled = atMax;
      if (friendName) friendName.disabled = atMax;
      if (friendRole) friendRole.disabled = atMax;
      if (atMax && friendName) { friendName.value = ''; }
      if (atMax && friendRole) { friendRole.value = ''; }
      if (this.elFriendHint) {
        this.elFriendHint.innerHTML = atMax
          ? '✓ Hai aggiunto il massimo (3). Clicca un amico qui sopra per modificarlo o ✕ per rimuoverlo.'
          : 'Premi <strong>+</strong>, <strong>Enter</strong> o esci dal campo per confermare. Max 3.';
      }
    }

    go(n) {
      if (n < 1) n = 1;
      if (n > this.totalSteps) n = this.totalSteps;
      this.step = n;
      this.renderStep();
    }

    renderStep() {
      this.steps.forEach((s) => {
        const isActive = Number(s.getAttribute('data-step')) === this.step;
        s.hidden = !isActive;
        s.classList.toggle('ci-brief__step--active', isActive);
      });
      if (this.elStepNum) this.elStepNum.textContent = String(this.step);
      if (this.elStepNumF) this.elStepNumF.textContent = String(this.step);
      if (this.elProgFill) this.elProgFill.style.width = `${(this.step / this.totalSteps) * 100}%`;
      if (this.elPrev) this.elPrev.disabled = this.step === 1;
      const isEmailStep = this.step === this.totalSteps;
      if (this.elNext) {
        this.elNext.hidden = isEmailStep;
        // Defensive: alcuni CSS impostano display sul .ci-brief__btn → forziamo "none" inline
        this.elNext.style.display = isEmailStep ? 'none' : '';
        this.elNext.disabled = isEmailStep;       // fallback se anche il display viene sovrascritto
        this.elNext.textContent = { 1: 'andiamo →', 2: 'perfetto, vai →', 3: 'ultimo passo →' }[this.step] || 'avanti →';
      }
      if (this.elSubmit) {
        this.elSubmit.hidden = !isEmailStep;
        this.elSubmit.style.display = isEmailStep ? '' : 'none';
      }
      this._refreshSubmitState();
      if (isEmailStep) setTimeout(() => this.elEmailInput?.focus(), 60);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    /* Click "apri il pacco" allo step 4: valida tutto, iscrive, genera */
    async onSubmitClick() {
      if (!this._briefingComplete()) {
        alert('Compila almeno età, occasione, vibe e nome festeggiato (passi 1-2).');
        this.go(this.state.honoree ? 1 : 2);
        return;
      }
      const email = (this.state.email || '').trim();
      if (!this._isValidEmail(email)) {
        this._showEmailError('Inserisci una email valida.');
        this.elEmailInput?.focus();
        return;
      }
      if (this.state.consent === false) {
        this._showEmailError('Devi accettare per ricevere le carte via email.');
        return;
      }

      const originalLabel = this.elSubmit?.textContent || '✨ apri il pacco';
      if (this.elSubmit) { this.elSubmit.disabled = true; this.elSubmit.textContent = 'iscrizione…'; }

      // Newsletter signup — endpoint backend Vercel /api/newsletter
      // (Shopify Admin GraphQL server-to-server, bypassa CAPTCHA storefront).
      if (!this.emailGateUnlocked || this.email !== email) {
        try {
          // L'URL endpoint preview-public ci dà il base origin Vercel.
          // Sostituiamo il path con /api/newsletter.
          let newsletterUrl = '';
          try {
            const u = new URL(this.previewEndpoint, window.location.origin);
            u.pathname = '/api/newsletter';
            u.search = '';
            newsletterUrl = u.toString();
          } catch (_e) {
            newsletterUrl = 'https://shopify-memes-411b.vercel.app/api/newsletter';
          }
          console.log('[preview-quiz] newsletter POST →', newsletterUrl);
          const resp = await fetch(newsletterUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, tags: this.newsletterTags })
          }).catch((e) => { console.warn('[preview-quiz] newsletter fetch error:', e); return null; });
          if (resp) {
            const data = await resp.json().catch(() => ({}));
            console.log('[preview-quiz] newsletter response', resp.status, data);
          }
        } catch (e) {
          console.warn('[preview-quiz] newsletter signup error:', e);
        }
        this.email = email;
        this.emailGateUnlocked = true;
      }

      if (this.elSubmit) { this.elSubmit.textContent = originalLabel; }
      await this.generatePreview();
    }

    /* Genera preview: 3 SS via backend + 4 generali dal pool */
    async generatePreview() {
      if (!this._briefingComplete()) {
        alert('Compila almeno età, occasione, vibe e nome festeggiato.');
        return;
      }

      this._showLoading();

      // Pesca 4 generali dal pool (frontend)
      const TOV_MAP = { irriverente: 'educato', chaos: 'educato', spicy: 'spinto' };
      const tov = TOV_MAP[this.state.vibe] || 'educato';
      const pool = (window.MEMANDOCON_POOL && window.MEMANDOCON_POOL.base && window.MEMANDOCON_POOL.expansion) ? window.MEMANDOCON_POOL : null;
      let generals = [];
      if (pool) {
        const allTOV = [...(pool.base[tov] || []), ...(pool.expansion[tov] || [])];
        const noName = allTOV.filter((c) => !/\[NOME\]/.test(c));
        const maturity = computeMaturity(this.state.age, this.state.occasion);
        const spice = computeSpice(this.state.vibe, this.state.occasion);
        const filtered = filterPool(noName, maturity, spice);
        const source = filtered.length >= 4 ? filtered : noName;
        // Fisher-Yates parziale
        const a = source.slice();
        for (let i = 0; i < 4; i++) {
          const idx = Math.floor(Math.random() * (a.length - i));
          generals.push(a[idx]);
          a[idx] = a[a.length - 1 - i];
        }
      }

      // Backend: 3 SS
      let ss = [];
      try {
        const r = await fetch(this.previewEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: this.email || this.state.email || null,
            briefing: {
              honoree: this.state.honoree,
              age: this.state.age,
              occasion: this.state.occasion,
              vibe: this.state.vibe,
              friends: this.state.friends,
              lore: this.state.lore,
              extraStory: this.state.extraStory,
            }
          }),
        });
        const d = await r.json().catch(() => null);
        if (!r.ok || !d || !Array.isArray(d.cards)) {
          const msg = (d && (d.message || d.error)) || ('errore ' + r.status);
          this._showError(msg);
          return;
        }
        ss = d.cards;
        // Salva sessionId per collegarlo all'ordine se il cliente compra
        if (d.sessionId) this.sessionId = d.sessionId;
      } catch (e) {
        this._showError('errore di rete: ' + (e?.message || ''));
        return;
      }

      // Mix 3 SS + 4 generali (SS in mezzo, generali ai bordi per "wow" centrale)
      this.deck = [
        ...generals.slice(0, 2).map((text, i) => ({ id: `g-${i}`, text, tier: 'general' })),
        ...ss.map((c, i) => ({ id: c.id || `ss-${i}`, text: c.text, tier: 'situation_ship' })),
        ...generals.slice(2).map((text, i) => ({ id: `g-x-${i}`, text, tier: 'general' })),
      ];

      this._showDeck();
    }

    _injectFormCSS() {
      if (document.getElementById('ci-preview-quiz-css')) return;
      const s = document.createElement('style');
      s.id = 'ci-preview-quiz-css';
      s.textContent = `
        .ci-brief-v4 .ci-brief__chip { display: inline-flex; align-items: center; padding: 10px 18px; margin: 0 8px 8px 0; background: #FFFFFF; color: #281C5E; border: 2px solid #281C5E; border-radius: 999px; font-family: 'Bricolage Grotesque', system-ui, sans-serif; font-weight: 700; font-size: 14px; cursor: pointer; transition: all 0.2s; line-height: 1; }
        .ci-brief-v4 .ci-brief__chip:hover { transform: translateY(-2px); box-shadow: 0 4px 12px rgba(40,28,94,0.18); background: #FEF9EF; }
        .ci-brief-v4 .ci-brief__chip--active { background: #281C5E !important; color: #C8E420 !important; transform: scale(1.05); box-shadow: 0 4px 14px rgba(40,28,94,0.35); }
        .ci-brief-v4 .ci-brief__chips { display: flex; flex-wrap: wrap; gap: 0; margin-bottom: 8px; }
        .ci-brief-v4 .ci-brief__field-title { font-family: 'Bricolage Grotesque', system-ui, sans-serif; font-weight: 800; font-size: 15px; text-transform: uppercase; letter-spacing: 0.8px; color: #281C5E; margin: 28px 0 6px; }
        .ci-brief-v4 .ci-brief__input, .ci-brief-v4 .ci-brief__textarea { display: block; width: 100%; padding: 14px 16px; background: #FFFFFF; color: #281C5E; border: 2px solid rgba(40,28,94,0.25); border-radius: 12px; font-family: 'Bricolage Grotesque', system-ui, sans-serif; font-weight: 500; font-size: 15px; line-height: 1.4; box-sizing: border-box; transition: border-color 0.2s, box-shadow 0.2s; }
        .ci-brief-v4 .ci-brief__textarea { resize: vertical; min-height: 80px; }
        .ci-brief-v4 .ci-brief__input:focus, .ci-brief-v4 .ci-brief__textarea:focus { outline: none; border-color: #281C5E; box-shadow: 0 0 0 4px rgba(200,228,32,0.30); }
        .ci-brief-v4 .ci-brief__friend { display: flex; align-items: center; justify-content: space-between; gap: 10px; background: #FFFFFF; border: 2px solid #281C5E; border-radius: 10px; padding: 10px 12px 10px 14px; font-family: 'Bricolage Grotesque', system-ui, sans-serif; font-size: 14px; color: #281C5E; cursor: pointer; transition: background 0.15s, transform 0.15s, box-shadow 0.15s; }
        .ci-brief-v4 .ci-brief__friend:hover { background: #FEF9EF; transform: translateY(-1px); box-shadow: 0 4px 10px rgba(40,28,94,0.15); }
        .ci-brief-v4 .ci-brief__friend:focus-visible { outline: none; box-shadow: 0 0 0 3px rgba(200,228,32,0.45); }
        .ci-brief-v4 .ci-brief__friend-text { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
        .ci-brief-v4 .ci-brief__friend-remove { background: none; border: none; color: #281C5E; cursor: pointer; opacity: 0.5; font-size: 14px; padding: 4px 6px; border-radius: 6px; flex-shrink: 0; transition: opacity 0.15s, background 0.15s; }
        .ci-brief-v4 .ci-brief__friend-remove:hover { opacity: 1; background: rgba(40,28,94,0.08); }
        .ci-brief-v4 .ci-brief__add { background: transparent; color: #281C5E; border: 2px dashed #281C5E; border-radius: 999px; padding: 10px 20px; font-weight: 700; font-size: 13px; cursor: pointer; font-family: 'Bricolage Grotesque', system-ui, sans-serif; }
        .ci-brief-v4 .ci-brief__add:hover { background: #281C5E; color: #FEF9EF; }
        .ci-brief-v4 .ci-brief__nav { background: rgba(254,249,239,0.95); backdrop-filter: blur(8px); border-top: 2px solid rgba(40,28,94,0.12); padding: 14px 16px; }
        .ci-brief-v4 .ci-brief__nav-inner { display: flex; align-items: center; justify-content: space-between; gap: 12px; max-width: 900px; margin: 0 auto; }
        .ci-brief-v4 .ci-brief__nav-step { font-family: monospace; font-size: 12px; color: rgba(40,28,94,0.55); letter-spacing: 1px; text-transform: uppercase; }
        .ci-brief-v4 .ci-brief__btn { font-family: 'Bricolage Grotesque', system-ui, sans-serif; font-weight: 800; font-size: 14px; padding: 14px 24px; border-radius: 999px; border: 2px solid #281C5E; cursor: pointer; transition: all 0.2s; }
        .ci-brief-v4 .ci-brief__btn:disabled { opacity: 0.35; cursor: not-allowed; }
        .ci-brief-v4 .ci-brief__btn--prev { background: transparent; color: #281C5E; }
        .ci-brief-v4 .ci-brief__btn--prev:hover:not(:disabled) { background: #281C5E; color: #FEF9EF; }
        .ci-brief-v4 .ci-brief__btn--next { background: #281C5E; color: #FEF9EF; }
        .ci-brief-v4 .ci-brief__btn--next:hover { background: #C8E420; color: #281C5E; border-color: #C8E420; transform: translateY(-2px); }
        .ci-brief-v4 .ci-brief__btn--generate { background: linear-gradient(135deg, #C8E420 0%, #f06b8c 100%); color: #281C5E; border-color: transparent; font-size: 15px; padding: 16px 28px; box-shadow: 0 6px 20px rgba(240,107,140,0.35); }
        .ci-brief-v4 .ci-brief__btn--generate:hover { transform: translateY(-3px) scale(1.02); }
        .ci-preview-board { display: grid; gap: 16px; }
        @media (max-width: 1000px) { .ci-preview-board { grid-template-columns: repeat(3, minmax(0, 1fr)) !important; } }
        @media (max-width: 720px)  { .ci-preview-board { grid-template-columns: repeat(2, minmax(0, 1fr)) !important; } }
        @media (max-width: 460px)  { .ci-preview-board { grid-template-columns: 1fr !important; } }
        .ci-preview-card { background: #5546A0; color: #FFFFFF; border-radius: 14px; padding: 20px 18px 18px; min-height: 260px; display: flex; flex-direction: column; justify-content: space-between; font-family: 'Bricolage Grotesque', sans-serif; font-weight: 400; font-size: 18px; line-height: 1.32; opacity: 0; transform: translateY(20px) scale(0.95); animation: ci-prev-in 0.5s ease-out forwards; box-shadow: 0 6px 18px rgba(85,70,155,0.30); gap: 12px; }
        .ci-preview-card-text { flex: 1; padding-top: 2px; font-weight: 400; }
        .ci-preview-card-text .ci-name-hl { color: #C7E420; font-weight: 400; }
        .ci-preview-card__bottom { display: flex; align-items: flex-end; justify-content: space-between; gap: 8px; }
        .ci-preview-card__ss-meta { display: flex; flex-direction: column; gap: 8px; align-items: flex-start; }
        .ci-preview-card-pretitle { font-family: 'Bricolage Grotesque', sans-serif; font-weight: 700; font-size: 11px; line-height: 1.2; color: rgba(255,255,255,0.55); text-transform: none; letter-spacing: 0; }
        .ci-preview-card-pill { display: inline-block; background: #C7E420; color: #281C5E; padding: 4px 11px; border-radius: 999px; font-weight: 800; font-size: 11px; letter-spacing: 0.3px; text-transform: lowercase; transform: rotate(-6deg); }
        .ci-preview-card-footer { font-family: 'Bricolage Grotesque', sans-serif; font-weight: 600; font-size: 14px; color: #f5b8c9; letter-spacing: 0; text-transform: none; }
        @keyframes ci-prev-in { to { opacity: 1; transform: translateY(0) scale(1); } }
      `;
      document.head.appendChild(s);
    }

    _showLoading() {
      if (!this.elReveal) return;
      const nav = $('.ci-brief__nav', this.root);
      if (nav) nav.style.display = 'none';
      const body = $('.ci-brief__body', this.root);
      if (body) body.style.display = 'none';
      const progress = $('.ci-brief__progress', this.root);
      if (progress) progress.style.display = 'none';

      this.elReveal.hidden = false;
      this.elReveal.innerHTML = `<div style="padding: 60px 24px; text-align: center; background: #FEF9EF;">
        <div style="font-family: 'Bricolage Grotesque', sans-serif; font-weight: 900; font-size: 28px; color: #281C5E; margin-bottom: 12px;">stiamo cucinando…</div>
        <div style="font-size: 14px; opacity: 0.6; color: #281C5E;">qualche secondo, ne vale la pena.</div>
      </div>`;
      window.scrollTo({ top: this.elReveal.offsetTop - 80, behavior: 'smooth' });
    }

    _showError(msg) {
      if (!this.elReveal) return;
      this.elReveal.innerHTML = `<div style="padding: 40px 24px; text-align: center; background: #FEF9EF;">
        <div style="font-family: 'Bricolage Grotesque', sans-serif; font-weight: 900; font-size: 22px; color: #C8233B;">qualcosa è andato storto</div>
        <div style="font-size: 14px; opacity: 0.7; color: #281C5E; margin-top: 6px;">${msg}</div>
        <button type="button" id="prev-retry" style="margin-top: 18px; padding: 12px 24px; background: #281C5E; color: #FEF9EF; border: none; border-radius: 999px; font-weight: 800; cursor: pointer;">riprova</button>
      </div>`;
      document.getElementById('prev-retry')?.addEventListener('click', () => this.generatePreview());
    }

    _showDeck() {
      if (!this.elReveal) return;
      const honoreeUpper = (this.state.honoree || '').toUpperCase();
      const regenLabel = this.root.dataset.regenLabel || '🔄 rigenera le carte (1 volta sola)';
      const regenUsedLabel = this.root.dataset.regenUsedLabel || '✓ rigenerazione usata';
      const postTitle = this.root.dataset.postorderTitle || "Questo è solo l'inizio";
      const postText = this.root.dataset.postorderText || "Dopo l'acquisto puoi modificare manualmente ogni carta a piacimento e caricare le tue foto personali. Ti arriverà via email il link per editare il mazzo.";

      const matchImage = this.root.dataset.matchImage || '';
      const matchTitle = this.root.dataset.matchTitle || 'Fai il tuo Match!';
      // dataset normalizes kebab-case to camelCase: data-match-annotation-1 → matchAnnotation1
      const matchAnnotation1 = this.root.dataset.matchAnnotation1 || 'Carica le peggio foto del festeggiato!';
      const matchAnnotation2 = this.root.dataset.matchAnnotation2 || 'Personalizza se vuoi le carte testo come più ti piace!';
      const matchPhoto1 = this.root.dataset.matchPhoto1 || '';
      const matchPhoto2 = this.root.dataset.matchPhoto2 || '';
      const honoreeName = this.state.honoree || 'Marco';
      // Fallback robust per nomi amici (filtra blank/troppo brevi)
      const validFriend = (n) => (typeof n === 'string' && n.trim().length >= 2 ? n.trim() : null);
      const friend1 = validFriend(this.state.friends[0]?.name) || 'Giulia';
      const friend2 = validFriend(this.state.friends[1]?.name) || 'Luca';

      this.elReveal.innerHTML = `<div style="padding: 40px 16px; background: #FEF9EF;">
        <h2 style="text-align:center; font-family: 'Bricolage Grotesque', sans-serif; font-weight: 900; font-size: clamp(24px,4vw,36px); color: #281C5E; margin: 0 0 8px;">ecco le tue 7 carte di prova</h2>
        <p style="text-align:center; color: rgba(40,28,94,0.7); margin: 0 0 24px;">3 ${honoreeUpper} situationship + 4 universali · le altre 93 le crei dopo l'acquisto</p>
        <div id="prev-board" class="ci-preview-board" style="display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 16px; max-width: 1200px; margin: 0 auto;"></div>

        <div class="ci-preview-deck-actions">
          <button type="button" class="ci-preview-regen-btn" data-preview-regen ${this.regenerationsUsed >= this.MAX_REGENERATIONS ? 'disabled' : ''}>
            ${this.regenerationsUsed >= this.MAX_REGENERATIONS ? regenUsedLabel : regenLabel}
          </button>
          <div class="ci-preview-regen-hint">Puoi rigenerare solo una volta. Dopo l'acquisto potrai editare ogni carta a mano.</div>
        </div>

        <section class="ci-preview-match">
          <header class="ci-preview-match__head">
            <h2 class="ci-preview-match__h2">${postTitle}</h2>
            <p class="ci-preview-match__sub">${postText}</p>
          </header>

          ${matchImage ? `
            <div class="ci-preview-match__image-wrap">
              <img class="ci-preview-match__image" src="${matchImage}" alt="Fai il tuo Match — anteprima personalizzazione" loading="lazy">
            </div>
          ` : `
          <div class="ci-preview-match__stage">
            ${matchPhoto2 ? `<div class="ci-preview-match__photo ci-preview-match__photo--2"><img src="${matchPhoto2}" alt="" loading="lazy"></div>` : `<div class="ci-preview-match__photo ci-preview-match__photo--2 ci-preview-match__photo--placeholder"></div>`}
            ${matchPhoto1 ? `<div class="ci-preview-match__photo ci-preview-match__photo--1"><img src="${matchPhoto1}" alt="" loading="lazy"></div>` : `<div class="ci-preview-match__photo ci-preview-match__photo--1 ci-preview-match__photo--placeholder"></div>`}

            <div class="ci-preview-match__card ci-preview-match__card--1">
              <span class="ci-preview-match__card-q">Quando</span>
              <strong class="ci-preview-match__card-name ci-preview-match__card-name--yellow">${this._esc(honoreeName.toLowerCase())}</strong>
              <span class="ci-preview-match__card-body">dice "No, questa volta non ci torno più insieme!"</span>
              <span class="ci-preview-match__card-foot">memando®</span>
            </div>
            <div class="ci-preview-match__card ci-preview-match__card--2">
              <span class="ci-preview-match__card-q">Quando</span>
              <strong class="ci-preview-match__card-name ci-preview-match__card-name--yellow">${this._esc(friend1.toLowerCase())}</strong>
              <span class="ci-preview-match__card-body">ti scrive per dirti che ha un ritardo nel ciclo ma avete fatto solo preliminari</span>
              <span class="ci-preview-match__card-foot">memando®</span>
            </div>
            <div class="ci-preview-match__card ci-preview-match__card--3">
              <span class="ci-preview-match__card-q">Quando</span>
              <strong class="ci-preview-match__card-name ci-preview-match__card-name--pink">${this._esc(friend2.toLowerCase())}</strong>
              <span class="ci-preview-match__card-body">al quarto Gin Tonic inizia a parlare dei suoi traumi di infanzia</span>
              <span class="ci-preview-match__card-foot">memando®</span>
            </div>

            <div class="ci-preview-match__title-wrap" aria-hidden="true">
              <span class="ci-preview-match__title-fai">Fai il tuo</span>
              <span class="ci-preview-match__title-match">${this._esc(matchTitle.replace(/^Fai il tuo\s*/i, ''))}</span>
            </div>

            <div class="ci-preview-match__annot ci-preview-match__annot--1">
              <span class="ci-preview-match__annot-text">${this._esc(matchAnnotation1)}</span>
              <svg class="ci-preview-match__annot-arrow ci-preview-match__annot-arrow--1" viewBox="0 0 80 80" aria-hidden="true">
                <path d="M8,8 C28,16 44,32 52,56" fill="none" stroke="#281C5E" stroke-width="2.2" stroke-linecap="round"/>
                <path d="M46,50 L54,60 L60,50" fill="none" stroke="#281C5E" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>

            <div class="ci-preview-match__annot ci-preview-match__annot--2">
              <span class="ci-preview-match__annot-text">${this._esc(matchAnnotation2)}</span>
              <svg class="ci-preview-match__annot-arrow ci-preview-match__annot-arrow--2" viewBox="0 0 80 80" aria-hidden="true">
                <path d="M70,65 C50,55 30,40 16,18" fill="none" stroke="#281C5E" stroke-width="2.2" stroke-linecap="round"/>
                <path d="M22,18 L14,12 L20,6" fill="none" stroke="#281C5E" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
          `}
        </section>
      </div>`;

      const board = document.getElementById('prev-board');
      // Capital-initial format e lista nomi conosciuti per highlight
      const titleCase = (s) => { const t = String(s||'').trim(); return t ? t[0].toUpperCase() + t.slice(1).toLowerCase() : ''; };
      const honoreeTC = titleCase(this.state.honoree);
      const knownNames = [honoreeTC, ...(this.state.friends || []).map((f) => titleCase(f.name))].filter(Boolean);
      const highlightNames = (text) => {
        let out = text;
        knownNames.forEach((n) => {
          if (!n || n.length < 2) return;
          const re = new RegExp(`\\b${n.replace(/[.*+?^${}()|[\\]\\\\]/g, '\\$&')}\\b`, 'gi');
          out = out.replace(re, `<span class="ci-name-hl">${n}</span>`);
        });
        return out;
      };

      this.deck.forEach((c, i) => {
        setTimeout(() => {
          const div = document.createElement('div');
          div.className = `ci-preview-card ${c.tier === 'situation_ship' ? 'ci-preview-card--ss' : ''}`;
          const safe = String(c.text || '').replace(/</g, '&lt;');
          const text = highlightNames(safe);
          if (c.tier === 'situation_ship') {
            div.innerHTML = `<div class="ci-preview-card-text">${text}</div>
              <div class="ci-preview-card__bottom">
                <div class="ci-preview-card__ss-meta">
                  <div class="ci-preview-card-pretitle">Oh yes!<br>Hai pescato<br>una:</div>
                  <span class="ci-preview-card-pill">${honoreeTC || honoreeUpper.toLowerCase()} situationship</span>
                </div>
                <div class="ci-preview-card-footer">memando</div>
              </div>`;
          } else {
            div.innerHTML = `<div class="ci-preview-card-text">${text}</div>
              <div class="ci-preview-card__bottom">
                <span></span>
                <div class="ci-preview-card-footer">memando</div>
              </div>`;
          }
          board.appendChild(div);
        }, i * 120);
      });

      // Bind del bottone rigenera (1 volta)
      const regenBtn = this.elReveal.querySelector('[data-preview-regen]');
      regenBtn?.addEventListener('click', () => this.regenerateOnce());

      // Mostra pacchetti dopo che le carte sono apparse, poi anche i mockup
      setTimeout(() => {
        if (this.elPackages) {
          this.elPackages.hidden = false;
          this.elPackages.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        if (this.elAftersale) this.elAftersale.hidden = false;
        if (this.elMockups) this.elMockups.hidden = false;
      }, this.deck.length * 120 + 800);
    }

    async regenerateOnce() {
      if (this.regenerationsUsed >= this.MAX_REGENERATIONS) return;
      this.regenerationsUsed += 1;
      // Nascondi pacchetti / aftersale / mockup durante la rigenerazione
      if (this.elPackages) this.elPackages.hidden = true;
      if (this.elAftersale) this.elAftersale.hidden = true;
      if (this.elMockups) this.elMockups.hidden = true;
      await this.generatePreview();
    }

    /* Add to cart Shopify: include line item properties dal questionario + sessionId */
    async addToCart(variantId) {
      const properties = {
        Festeggiato: this.state.honoree,
        Occasione: this.state.occasion,
        Vibe: this.state.vibe,
        Eta: this.state.age,
      };
      if (this.state.lore) properties.Lore = this.state.lore;
      if (this.state.extraStory) properties['Aneddoto'] = this.state.extraStory;
      this.state.friends.forEach((f, i) => {
        properties[`Amico ${i + 1}`] = `${f.name}${f.role ? ` (${f.role})` : ''}`;
      });
      // Shopify nasconde le properties che iniziano con _ (non visibili al cliente)
      // Usato dal webhook orders/create per pre-popolare il briefing
      if (this.sessionId) properties['_preview_session_id'] = this.sessionId;
      if (this.email) properties['_preview_email'] = this.email;

      try {
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1, properties }),
        });
        if (!r.ok) {
          alert('Errore aggiunta al carrello. Ricarica e riprova.');
          return;
        }
        window.location.href = '/cart';
      } catch (e) {
        alert('Errore di rete: ' + (e?.message || ''));
      }
    }

    persist() {
      try { localStorage.setItem(AUTOSAVE_KEY, JSON.stringify(this.state)); } catch (_e) {}
    }
    loadState() {
      try {
        const raw = localStorage.getItem(AUTOSAVE_KEY);
        return raw ? JSON.parse(raw) : null;
      } catch (_e) { return null; }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('[data-ci-preview-quiz]');
    if (!root) return;
    new PreviewQuiz(root);
  });
})();